import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"

vue.use(vuex);

const clasificacion = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/clasificacion`,
    state: {
        clasificaciones: []
        , clasificaciones_adm : []
      ,  clasificacionescategoria: [] 
      ,  clasificacionescategoriaentidad: []   
      , clasificacionallsector: []
    }
}).get({
    action: "get_clasificacionperiodo",
    path: function (obj) {        
        
        return `/detalle/${obj.periodoId}`;
    }
    ,
    onSuccess: (state, payload) => {              
        state.clasificaciones = payload.data;
    }
}).get({
    action: "get_clasificaciones",   
    onSuccess: (state, payload) => {  
        state.clasificaciones = payload.data;
    }
}).get({
    action: "get_clasificacionessector",
    path: function (obj) {        
        return `/detalle/${obj.periodoId}/idsector=${obj.idsector}`;
    }
    ,
    onSuccess: (state, payload) => {        
        state.clasificacionescategoria = payload.data;
    }
}).get({
    action: "get_clasificacionesAllsector",
    path: function (obj) {        
        return `/detalleallsector/${obj.periodoId}`;
    },
    onSuccess: (state, payload) => {        
        state.clasificacionallsector = payload.data;
    }
}).get({
    action: "get_clasificacionesentidad",
    path: function (obj) {        
        return `/detalle/${obj.periodoId}/identidad=${obj.identidad}`;
    }
    ,
    onSuccess: (state, payload) => {        
        state.clasificacionescategoriaentidad = payload.data;
    }
}).getStore();

clasificacion.getters = {
    gclasificaciones: state => {
        return state.clasificaciones
    },
    gclasificacionescategoria: state => {
        return state.clasificacionescategoria
    },
    gclasificacionescategoriaentidad: state => {
        return state.clasificacionescategoriaentidad
    },
    gclasificacionescategoriaAllsector: state => {
        return state.clasificacionallsector
    },
    gclasificacionesvisibles: state => {
        return state.clasificaciones.filter(p=> p.visible === true)
    }
}

export default clasificacion;
